import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

import useDispatch from 'client/hooks/useDispatch';
import postWithState from 'client/actions/postWithState';

import {
  SR_API_ACTION_GOOGLE_MAPS_GET_AUTOCOMPLETE_PREDICTIONS,
  SR_API_ACTION_GOOGLE_MAPS_GET_PLACE_DETAILS,
} from 'api/actionTypes';
import emptyFunction from 'common/util/emptyFunction';
import { extractListingAddressFieldsFromGooglePlace } from 'client/lib/googlePlaces';

const SrFormFieldGoogleAddressAutoComplete = ({
  value,
  formField,
  onChange,
  textInputFieldAttributes = {},
  onBlur,
  onSelectAddress,
}) => {
  const [googleAddressMatches, setGoogleAddressMatches] = useState([]);
  const [shouldRenderSuggestions, setShouldRenderSuggestions] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const dispatch = useDispatch();

  const searchAddress = (newValue) => {
    dispatch(postWithState, {
      queryId: `${formField.id}_${newValue}`,
      action: SR_API_ACTION_GOOGLE_MAPS_GET_AUTOCOMPLETE_PREDICTIONS,
      payload: {
        input: newValue,
        limitToTexas: false,
      },
    }).then((autocompletePredictions) => {
      setGoogleAddressMatches(autocompletePredictions);
    });
  };

  const fetchAddressDetails = async (suggestion) => {
    const { place_id, description } = suggestion;

    onChange(description);

    setGoogleAddressMatches([]);
    setShouldRenderSuggestions(false);

    const addressDetails = await dispatch(postWithState, {
      queryId: `${formField.id}_${place_id}`,
      action: SR_API_ACTION_GOOGLE_MAPS_GET_PLACE_DETAILS,
      payload: {
        placeId: suggestion.place_id,
      },
    });

    const fields = extractListingAddressFieldsFromGooglePlace(addressDetails);

    if (onSelectAddress) {
      onSelectAddress(fields);
      setSelectedAddress(fields);
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur(selectedAddress);
    }
  };

  return (
    <>
      <Autosuggest
        suggestions={googleAddressMatches.map(({ description, place_id }) => ({
          place_id,
          description,
        }))}
        onSuggestionsClearRequested={emptyFunction}
        onSuggestionsFetchRequested={emptyFunction}
        getSuggestionValue={(suggestion) => suggestion.description}
        renderSuggestion={(suggestion) => suggestion.description}
        shouldRenderSuggestions={() => shouldRenderSuggestions}
        onSuggestionSelected={(event, { suggestion }) => {
          fetchAddressDetails(suggestion);
        }}
        inputProps={{
          ...textInputFieldAttributes,
          choices: googleAddressMatches.map(({ description, place_id }) => ({
            description,
            place_id,
          })),
          autoComplete: 'off',
          value: value || '',
          onChange: (event, { newValue }) => {
            onChange(newValue);
            searchAddress(newValue);
            setShouldRenderSuggestions(true);

            if (selectedAddress && onSelectAddress) {
              onSelectAddress(null);
              setSelectedAddress(null);
            }
          },
          onBlur: handleBlur,
        }}
      />
    </>
  );
};
SrFormFieldGoogleAddressAutoComplete.propTypes = {
  value: PropTypes.string,
  formField: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  textInputFieldAttributes: PropTypes.object,
  onBlur: PropTypes.func,
  onSelectAddress: PropTypes.func,
};
export default SrFormFieldGoogleAddressAutoComplete;
